import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLE_HOME = {
  super_admin: '/super-admin/dashboard',
  admin: '/admin/dashboard',
  principal: '/principal/dashboard',
  class_teacher: '/teacher/dashboard',
  parent: '/parent/dashboard',
};

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const homePath = ROLE_HOME[user?.role] || '/login';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center max-w-md">
        <div className="text-7xl mb-4">🧭</div>
        <h1 className="text-4xl font-bold text-gray-800 mb-2">404</h1>
        <p className="text-lg font-semibold text-gray-700 mb-2">Page not found</p>
        <p className="text-gray-500 mb-8">The page you're looking for doesn't exist or may have been moved.</p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate(homePath)}
            className="px-5 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition font-medium"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
